import { baseApi, resourceScopeTag, resourceTag } from '@krp/client-runtime'

import { AQSI_TAG_TYPES, AQSI_TAGS } from '../../../shared/api/tags'
import { AQSI_URLS } from '../../../shared/api/urls'
import type { AqsiCreateDefaults, CreateDefaultValues } from '../model/types'
import { decodeCreateDefaults } from './contracts'

export interface CreateDefaultsArgs {
  resourceId: string
}

export interface SaveCreateDefaultsArgs extends CreateDefaultsArgs {
  values: CreateDefaultValues
  /** Ревизия, которую человек видел: чужая правка между чтением и сохранением — конфликт, а не перезапись. */
  expectedVersion: number
}

/**
 * «Создание по умолчанию» ресурса AQSI (RP-SYN12, SYNC-V2-PLAN 3.7). Чтение — шаблон создания с умолчаниями (категории кабинета служба читает
 * живьём, таблицы — из настроек ресурса); сохранение — один PUT целиком с ревизией, без повторов.
 */
export const createDefaultsApi = baseApi.enhanceEndpoints({ addTagTypes: AQSI_TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    aqsiCreateDefaults: build.query<AqsiCreateDefaults, CreateDefaultsArgs>({
      query: ({ resourceId }) => ({
        url: AQSI_URLS.createDefaults(resourceId),
        decode: (raw: unknown) => decodeCreateDefaults(raw, resourceId),
      }),
      providesTags: (_result, _error, { resourceId }) => [resourceTag(AQSI_TAGS.createDefaults, resourceId, 'defaults'), resourceScopeTag(resourceId)],
    }),
    aqsiSaveCreateDefaults: build.mutation<AqsiCreateDefaults, SaveCreateDefaultsArgs>({
      query: ({ resourceId, values, expectedVersion }) => ({
        url: AQSI_URLS.createDefaults(resourceId),
        method: 'PUT',
        body: { values, expectedVersion },
        decode: (raw: unknown) => decodeCreateDefaults(raw, resourceId),
      }),
      invalidatesTags: (_result, _error, { resourceId }) => [resourceTag(AQSI_TAGS.createDefaults, resourceId, 'defaults')],
    }),
  }),
})

export const { aqsiCreateDefaults, aqsiSaveCreateDefaults } = createDefaultsApi.endpoints
